import { FormikProps } from 'formik';
import React from 'react';
import { ComposableDeviceValues } from '../AddComposableDevice';
import { Box, Button, Stack } from '@mui/material';
import { getPolyglot } from '../../../../../i18n';
import { IconUpload } from '../../../../../redux/groups/groups.model';
import ButtonLoading from '../../../../../components/commons/ButtonLoading/ButtonLoading';
import ImageUploader from './ImageDropUpload';

export const ImageForm = ({
  formik,
  image,
  setLogo,
  setImage,
  logo,
  closeAddComposableDevice,
  displayButtons = true,
}: {
  formik: FormikProps<ComposableDeviceValues>;
  image: IconUpload | null;
  setLogo: React.Dispatch<React.SetStateAction<IconUpload | null>>;
  setImage: React.Dispatch<React.SetStateAction<IconUpload | null>>;
  logo: IconUpload | null;
  closeAddComposableDevice?: () => void;
  displayButtons?: boolean;
}) => {
  const polyglot = getPolyglot();
  const onLogoChange = (image: IconUpload | null) => {
    setLogo(image);
    setImage(image);
    formik.setFieldValue('logoURL', image?.imagePreviewUrl || null);
    formik.setFieldValue('imageURL', image?.imagePreviewUrl || null);
  };

  const isEditMode = Boolean(formik.values?.id);

  return (
    <Stack
      display={'flex'}
      flexDirection={'column'}
      spacing={2}
      alignItems={'flex-start'}
      justifyContent={'space-between'}
    >
      <ImageUploader
        initialImage={logo?.imagePreviewUrl}
        onImageChange={onLogoChange}
      />

      {!isEditMode && displayButtons ? (
        <Box
          mt={2}
          display="flex"
          justifyContent="flex-end"
          gap={2}
          width={'100%'}
        >
          <Button
            type="button"
            onClick={closeAddComposableDevice}
            variant="text"
          >
            {polyglot.t('device.cancel_button_title')}
          </Button>
          <ButtonLoading
            type="submit"
            variant="contained"
            onClick={formik.submitForm}
            disabled={formik.isSubmitting || !formik.isValid}
            loading={formik.isSubmitting}
          >
            {polyglot.t('device.add_button_title')}
          </ButtonLoading>
        </Box>
      ) : null}
    </Stack>
  );
};
